import React, { createContext, useState } from 'react';

const dark = 'dark';
const light = 'light';
export const themes = [dark, light];
const storageTheme = localStorage.getItem('theme');

export const ThemeContext = createContext({ theme: dark, toggleTheme: () => null });
export default function ThemeProvider({ children }) {
  if (!storageTheme) {
    localStorage.setItem('theme', dark);
  }
  const [theme, setTheme] = useState(storageTheme || dark);
  const toggleTheme = (index) => {
    const newTheme = themes[index];
    localStorage.setItem('theme', newTheme);
    setTheme(newTheme);
  };
  return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
}
